import { TranslateRoutePipe, TranslateRouterModule } from '@endeavour/ngx-translate-router'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { DirectivesModule } from '@app-directives/directives.module'
import { UIModule } from '@app-domains/ui/ui.module'
import { PipesModule } from '@app-pipes/pipes.module'
import { ContentBlocksModule } from '@app-domains/content-blocks/content-blocks.module'
import { ProductDownloadConfigModalComponent } from '@app-domains/product/components/product-download-config-modal/product-download-config-modal.component'
import { ColorVariantSelectorComponent } from './components/color-variant-selector/color-variant-selector.component'
import { GenericVariantSelectorComponent } from './components/generic-variant-selector/generic-variant-selector.component'
import { PriceAuthorisedComponent } from './components/price-authorised/price-authorised.component'
import { PriceUnauthorisedComponent } from './components/price-unauthorised/price-unauthorised.component'
import { VariantSelectorComponent } from './components/variant-selector/variant-selector.component'
import { WishlistButtonComponent } from './components/wishlist-button/wishlist-button.component'
import { AddToCartModalComponent } from './components/add-to-cart-modal/add-to-cart-modal.component'
import { LoadingModule } from '@app-domains/loading/loading.module'

@NgModule({
    declarations: [
        VariantSelectorComponent,
        GenericVariantSelectorComponent,
        ColorVariantSelectorComponent,
        PriceAuthorisedComponent,
        PriceUnauthorisedComponent,
        WishlistButtonComponent,
        AddToCartModalComponent,
    ],
    imports: [
        CommonModule,
        UIModule,
        DirectivesModule,
        PipesModule,
        ContentBlocksModule,
        TranslateRouterModule,
        LoadingModule,
        ProductDownloadConfigModalComponent,
    ],
    exports: [
        VariantSelectorComponent,
        ColorVariantSelectorComponent,
        PriceUnauthorisedComponent,
        PriceAuthorisedComponent,
        AddToCartModalComponent,
        ProductDownloadConfigModalComponent,
    ],
    providers: [
        {
            provide: TranslateRoutePipe,
            useClass: TranslateRoutePipe,
        },
    ],
})
export class ProductDomainModule { }
